import { isFacingTrigger, SYSTEM_FACING_MAX_PATHS, SYSTEM_WORKFLOW_LIMITS, WORKFLOW_LIMITS, type WorkflowTrigger } from "@sagot/constants";
import { useContext } from "react";
import { TriggerContext } from "../hook-model";
import { useDefaultWorkflow } from "./default-context";

/**
 * The most paths a workflow may have: a default stays basic, with fewer than a workflow of the workspace's own. A default on a
 * customer-facing trigger (the concern intake) may hold one path more ("that solved it").
 */
export function usePathLimit(workflowTrigger?: WorkflowTrigger): number {
  const inContext = useContext(TriggerContext);
  const trigger = workflowTrigger ?? inContext;
  if (!useDefaultWorkflow()) return WORKFLOW_LIMITS.paths;
  return trigger !== undefined && isFacingTrigger(trigger) ? SYSTEM_FACING_MAX_PATHS : SYSTEM_WORKFLOW_LIMITS.paths;
}
